<template>
  <RawRecords v-if="showRawOutput" :records="records" />
  <table v-else-if="processedRecords.length">
    <colgroup>
      <col style="width: 20%;">
      <col style="width: 20%;">
      <col style="width: 30%;">
      <col style="width: 30%;">
    </colgroup>
    <thead>
      <tr class="border-b-2 border-gray-200 text-left">
        <th scope="col" class="py-1.5 font-medium">Flags</th>
        <th scope="col" class="py-1.5 font-medium">Tag</th>
        <th scope="col" class="py-1.5 font-medium">Value</th>
        <th scope="col" class="py-1.5 font-medium">Revalidate in</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(record, index) in processedRecords" :key="index" class="group">
        <td>{{ record.record.flags }}</td>
        <td>{{ record.record.tag }}</td>
        <td>
          {{ record.record.value }}
          <CnameChainBadge :chain="record.cnameChain" />
          <copy :content="record.record.value" class="[visibility:hidden] group-hover:visible" /></td>
        <td><duration :seconds="record.record.ttl" /></td>
      </tr>
    </tbody>
  </table>
  <div v-else>No {{ recordType.plural }} found.</div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import { useStore } from 'vuex';
import Duration from '@/components/micro/DurationComponent.vue';
import Copy from '@/components/micro/CopyComponent.vue';
import RawRecords from '@/components/micro/RawRecords.vue';
import CnameChainBadge from '@/components/micro/CnameChainBadge.vue';
import { getRecordType } from '@/common/recordTypes';
import { CAA, QueryResult, RecordInfo } from '@/model/Api';

type CaaRecordWithInfo = {
  record: CAA;
} & RecordInfo

const props = defineProps({
  records: {
    type: Object as PropType<QueryResult>,
    required: true,
  },
});

const store = useStore();
const showRawOutput = computed(() => store.state.showRawOutput);

const recordType = getRecordType('CAA');

const processedRecords = computed(() => {
  const processed: CaaRecordWithInfo[] = props.records.response.answer.filter((item): item is CaaRecordWithInfo => item.record.recordType === recordType.upper);
  return processed;
});
</script>
